import { createAsyncThunk } from "@reduxjs/toolkit";
import { type UndeliveredCase } from "../../../domain/entities/undelivered";
import { type UndeliveredDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const loadCase = createAsyncThunk<
  UndeliveredCase,
  string,
  { dispatch: UndeliveredDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LOAD_CASE, async (requestId, { extra }) => {
  return await extra.undeliveredRepo.loadCase(requestId);
});
